import Axios from '@/Axios'

class CommonApiService {
    async getRoles(data={}){
        return await Axios.get('wms.wms.api.miscellaneous_api.get_roles',{
            params:data
        })
    }

    async logout() {
        return await Axios.post('wms.wms.api.auth.logout')
    }

    async getSession() {
        return await Axios.get('wms.wms.api.auth.get_current_user')
    }

    async forgotPassword(data) {
        return await Axios.post('wms.wms.api.auth.forgot_password', data)
    }

    async updatePassword(data) {
        return await Axios.post('wms.wms.api.auth.update_password', data)
    }
}

export default new CommonApiService()
